// extracted by mini-css-extract-plugin
export default {"tableContainer":"Table_tableContainer__Ncilo","tableHeader":"Table_tableHeader__HfytX","tableElement":"Table_tableElement__K5pgb"};